import { Module, GetterTree, MutationTree, ActionTree } from "vuex";
import { SOURCE } from "@/modules/julho_14/settings";
import { simulator } from "./simulator";
import api from "../api";

interface ITriaxialJoint {
    id: number;
    name: string;
}

interface IConcreteTemperatureThermometer {
    id: number;
    name: string;
}

export interface IJulho14State {
    triaxialJoints: ITriaxialJoint[];
    concreteTemperatureThermometers: IConcreteTemperatureThermometer[];
}

const initialState: IJulho14State = {
    triaxialJoints: [],
    concreteTemperatureThermometers: []
};

const actions: ActionTree<IJulho14State, any> = {
    async initialize({ dispatch }) {
        await dispatch("common/initialize", SOURCE, {
            root: true
        });
        await Promise.all([
            dispatch("getTriaxialJoints"),
            dispatch("getConcreteTemperatureThermometers")
        ]);
    },
    async getTriaxialJoints({ commit }) {
        const { data } = await api.triaxialJoints.list();
        commit("SET_TRIAXIAL_JOINTS", data);
    },
    async getConcreteTemperatureThermometers({ commit }) {
        const { data } = await api.concreteTemperatureThermometers.list();
        commit("SET_CONCRETE_TEMPERATURE_THERMOMETERS", data);
    }
};

const mutations: MutationTree<IJulho14State> = {
    SET_TRIAXIAL_JOINTS(state, triaxialJoints: ITriaxialJoint[]) {
        state.triaxialJoints = triaxialJoints;
    },
    SET_CONCRETE_TEMPERATURE_THERMOMETERS(
        state,
        concreteTemperatureThermometers: IConcreteTemperatureThermometer[]
    ) {
        state.concreteTemperatureThermometers = concreteTemperatureThermometers;
    }
};

const getters: GetterTree<IJulho14State, any> = {
    needInitialize(state, getters, rootState, rootGetters) {
        if (state.concreteTemperatureThermometers.length === 0) {
            return true;
        }
        if (state.triaxialJoints.length === 0) {
            return true;
        }
        const needInitializeList = [rootGetters["common/needInitialize"]];
        return needInitializeList.some(item => item);
    }
};

export const julho14: Module<IJulho14State, any> = {
    namespaced: true,
    state: initialState,
    mutations,
    actions,
    getters,
    modules: {
        simulator
    }
};
